import "@Styles/Shared/ActionToolbar/actionToolbar_sm.less";
import "@Styles/Shared/ActionToolbar/PB/actionToolbar_sm.less";
import "@Styles/Shared/ActionToolbar/actionToolbar_md.less";
import "@Styles/Shared/ActionToolbar/actionToolbar_lg.less";
import atObserver from './_actionToolbarObserver';
import emailButton from './Buttons/_emailButton';
import favoriteButton from './Buttons/_favoriteButton';
import printButton from './Buttons/_printButton';
import socialButton from './Buttons/_socialButton';
import wakeLockButton from './Buttons/_wakeLockButton';
import thirdPartyScriptButton from './Buttons/_thirdPartyScriptButton';
import modalButton from './Buttons/_modalButton';
import revealButton from './Buttons/_revealButton';
import copyLinkButton from './Buttons/_copyLinkButton';
import jumpToButton from './Buttons/_jumpToButton';
/* istanbul ignore next dynamic imports */

var emailModal = function emailModal() {
  return import(
  /* webpackChunkName: 'emailModal' */
  './Modals/emailModal');
};

var genericModal = function genericModal() {
  return import(
  /* webpackChunkName: 'genericlModal' */
  './Modals/genericModal');
};

export default {
  data: function data() {
    return {
      config: {},
      buttons: {},
      buttonClasses: {},
      pageAttributes: {},
      userSettings: {},
      observer: {},
      modalComponent: '',
      modalSettings: {},
      isModalVisible: false
    };
  },
  components: {
    // Make sure these component names correspond to the button type enum
    // GeneralMills.CIA.Framework.Controls.ActionToolbar.Entities.ButtonType
    'Email': emailButton,
    'Favorite': favoriteButton,
    'Print': printButton,
    'Social': socialButton,
    'WakeLock': wakeLockButton,
    'ThirdPartyScript': thirdPartyScriptButton,
    'Reveal': revealButton,
    'Modal': modalButton,
    'CopyLink': copyLinkButton,
    'JumpTo': jumpToButton,
    // modals
    'emailModal': emailModal,
    'genericModal': genericModal
  },
  methods: {
    init: function init(config) {
      this.config = config || {};
      this.pageAttributes = this.config.pageAttributes || {};
      this.userSettings = this.config.userSettings || {};

      if (config && config.toolbarSettings) {
        for (var i in config.toolbarSettings.buttons) {
          var button = config.toolbarSettings.buttons[i];
          this.$set(this.buttons, button.id, button);
        }

        if (config.toolbarSettings.isSticky === true) {
          this.observer = new atObserver();
        }
      }
    },
    setModalComponent: function setModalComponent(modalName, settings) {
      if (this.$options.components[modalName]) {
        this.modalComponent = modalName;
        this.modalSettings = settings;
        this.isModalVisible = true;
      }
    },
    hideModal: function hideModal() {
      this.modalComponent = null;
      this.isModalVisible = false;
    },
    setButtonClass: function setButtonClass(buttonId, buttonClass) {
      if (!buttonId) return;

      if (buttonClass) {
        this.$set(this.buttonClasses, buttonId, buttonClass);
      } else {
        this.$delete(this.buttonClasses, buttonId);
      }
    }
  }
};